import { render } from "./mega-menu.vue?vue&type=template&id=eace042a"
import script from "./mega-menu.vue?vue&type=script&lang=js"
export * from "./mega-menu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__